import { useCallback } from "react";
import {
  doc,
  updateDoc,
  arrayUnion,
  serverTimestamp,
} from "firebase/firestore";
import { useAuth } from "@/contexts/AuthContext";
import { db } from "@/integrations/firebase/firestore";
import { logError } from "@/shared/services/ErrorReporting";

export const useMarkJobOpened = () => {
  const { authUser } = useAuth();

  const markOpened = useCallback(
    async (jobId: string) => {
      const viewerEmail = authUser?.email?.toLowerCase();
      if (!viewerEmail) return;

      try {
        await updateDoc(doc(db, "shared_jobs", jobId), {
          has_opened_emails: arrayUnion(viewerEmail),
          updated_at: serverTimestamp(),
        });
      } catch (err) {
        logError(err as Error);
      }
    },
    [authUser],
  );

  return { markOpened };
};
